import KeyProcessor from '@/js/KeyProcessor'

export default methodName => ({
  data: () => ({ enterProcessor: null }),
  mounted() {
    this.enterProcessor = new KeyProcessor({ 13: this[methodName] })
  },
  destroyed() {
    this.enterProcessor.removeListener()
    this.enterProcessor = null
  }
})
